import { Big } from 'big.js';
import { match } from 'ts-pattern';
import { TenantJobLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import BreJob from '~/tenants/bre/model/BreJob';
import { BreOrderType } from '~/tenants/bre/model/enums';
import BreStagingConfig from '~/tenants/bre/performable/staging/BreStagingConfig';
import { BreStagingRate } from '~/tenants/bre/performable/staging/BreStagingData';

export default class BreStagingJob extends BreJob<typeof BreStagingConfig> {
  get performable(): typeof BreStagingConfig {
    return BreStagingConfig;
  }

  get configurable(): boolean {
    return true;
  }

  get assignable() {
    return true;
  }

  // get input(): TenantJobInput | null {
  //   return {
  //     performables: [BrePhotosConfig.id],
  //     required: this.metadata.quantity,
  //     title: 'Select Photos',
  //     description: 'Select the photos you want to have virtually staged.',
  //   };
  // }

  get eligible(): boolean {
    return this.isOneOf(BreOrderType.RESIDENTIAL, BreOrderType.COMMERCIAL, BreOrderType.RENTAL);
  }

  defaultValue(): ZodVersionedMetadata<(typeof BreStagingConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      style: 'modern',
      quantity: 1,
    };
  }

  revenueLines(): TenantJobLine[] {
    const { quantity, item_removal, space_renovation } = this.metadata;
    const { TIER_1, TIER_2, TIER_3, TIER_4, ITEM_REMOVAL, SPACE_RENOVATION } = BreStagingRate[this.order.metadata.type];
    const lines: TenantJobLine[] = [];
    const tier = match(quantity)
      .when(
        (q) => q <= 3,
        () => TIER_1,
      )
      .when(
        (q) => q <= 6,
        () => TIER_2,
      )
      .when(
        (q) => q <= 9,
        () => TIER_3,
      )
      .otherwise(() => TIER_4);

    lines.push({
      id: 'virtual_staging',
      description: `x${quantity} Virtual Staging`,
      amount: new Big(tier).times(quantity),
    });

    if (item_removal) {
      lines.push({
        id: 'item_removal',
        description: `x${item_removal} Items Removal`,
        amount: new Big(ITEM_REMOVAL).times(item_removal),
      });
    }

    if (space_renovation) {
      lines.push({
        id: 'space_renovation',
        description: `x${space_renovation} Space Renovations`,
        amount: new Big(SPACE_RENOVATION).times(space_renovation),
      });
    }

    return lines;
  }
}
